import React from "react";
import ProfilePage from "../../Pages/ProfilePage/ProfilePage";

export default function Profile() {
  return (
    <div>
      <ProfilePage />
    </div>
  );
}
